import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import { useAtomValue } from 'jotai';
import { authAtom } from '../state/authAtoms';
import EntryRequestsContainer from '../modules/EntryRequests/components/Containers/EntryRequestsContainer';
import GoodsContainer from '../modules/Goods/components/Containers/GoodsContainer';
import DirectGoodsContainer from '../modules/DirectGoods/components/Containers/DirectGoodsContainer';
import RefundsContainer from '../modules/Refunds/components/Containers/RefundsContainer';
import PetitionsContainer from '../modules/Petitions/components/Containers/PetitionsContainer';
import TransfersContainer from '../modules/Transfers/components/Containers/TransfersContainer';
import TechnicalConceptContainer from '../modules/TechnicalConcept/components/containers/TechnicalConceptContainer';
import OnlineInventoryContainer from '../modules/OnlineInventory/components/Containers/OnlineInventoryContainer';
import ApproveRequestsContainer from '../modules/ApproveRequests/components/Containers/ApproveRequestsContainer';
import InventoryViewContainer from '../modules/InventoryView/components/containers/InventoryViewContainer';
import WarehouseContainer from '../modules/WarehouseView/components/Containers/WarehouseContainer';
import ApprovalsTechnicalConceptContainer from '../modules/ApprovalsTechnicalConcept/components/containers/ApprovalsTechnicalConceptContainer';
import RequesedItemsViewContainer from '../modules/RequestedItems/components/containers/RequestedItemsViewContainer';

// Ruta privada
const PrivateRoute = ({ children }: { children: React.ReactNode }) => {
  const req = useAtomValue(authAtom);
  return req?.authorization?.token ? <>{children}</> : <Navigate to="/login" />;
};

const PrivateRoutes: React.FC = () => {
  return (
    <Routes>
      <Route element={<MainLayout />}>
        <Route
          path="/"
          element={
            <PrivateRoute>
              {/*   <DashboardContainer /> */}
              <PetitionsContainer />
            </PrivateRoute>
          }
        />
        <Route
          path="/myrequests"
          element={
            <PrivateRoute>
              <PetitionsContainer />
            </PrivateRoute>
          }
        />
        {/* ENTRY REQUEST PATH*/}
        <Route
          path="/entryrequests"
          element={
            <PrivateRoute>
              <EntryRequestsContainer />
            </PrivateRoute>
          }
        />
        <Route
          path="/goodsrequests"
          element={
            <PrivateRoute>
              <GoodsContainer />
            </PrivateRoute>
          }
        />
        <Route
          path="/directgoodsrequests"
          element={
            <PrivateRoute>
              <DirectGoodsContainer />
            </PrivateRoute>
          }
        />
        <Route
          path="/refunds"
          element={
            <PrivateRoute>
              <RefundsContainer />
            </PrivateRoute>
          }
        />
        <Route
          path="/transfers"
          element={
            <PrivateRoute>
              <TransfersContainer />
            </PrivateRoute>
          }
        />
        <Route
          path="/technicalconcept"
          element={
            <PrivateRoute>
              <TechnicalConceptContainer />
            </PrivateRoute>
          }
        />
        <Route
          path="/inventoryview"
          element={
            <PrivateRoute>
              <InventoryViewContainer />
            </PrivateRoute>
          }
        />
        {/* ONLINE INVENTORY PATH*/}
        <Route
          path="/onlineinventory"
          element={
            <PrivateRoute>
              <OnlineInventoryContainer />
            </PrivateRoute>
          }
        />
        {/* ONLINE INVENTORY PROGRAMMED PATH*/}
        <Route
          path="/onlineinventory-programmed"
          element={
            <PrivateRoute>
              <OnlineInventoryContainer />
            </PrivateRoute>
          }
        />
        {/* ONLINE INVENTORY ARCHIVED PATH*/}
        <Route
          path="/onlineinventoryarchived"
          element={
            <PrivateRoute>
              <OnlineInventoryContainer />
            </PrivateRoute>
          }
        />
        <Route
          path="/approve-request"
          element={
            <PrivateRoute>
              <ApproveRequestsContainer />
            </PrivateRoute>
          }
        />
        <Route
          path="/warehouse-view"
          element={
            <PrivateRoute>
              <WarehouseContainer />
            </PrivateRoute>
          }
        />

        <Route
          path="/approvals-technical-concepts"
          element={
            <PrivateRoute>
              <ApprovalsTechnicalConceptContainer />
            </PrivateRoute>
          }
        />
        <Route
          path="/requesed-items"
          element={
            <PrivateRoute>
              <RequesedItemsViewContainer />
            </PrivateRoute>
          }
        />
      </Route>
    </Routes>
  );
};

export default PrivateRoutes;
